import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getTypes = store => store[NAME].types;
export const getAccumList = store => store[NAME].accumList;
export const getProcessSelectionList = store => store[NAME].processSelectionList;